import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import Sidebar from '../components/Sidebar';
import toast from 'react-hot-toast';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './AddReport.css';

const AddReport = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const getReportDate = () => {
    const now = new Date();
    const cairoDate = new Date(now.toLocaleString('en-US', { timeZone: 'Africa/Cairo' }));
    const hour = cairoDate.getHours();
    
    if (hour < 7) {
      cairoDate.setDate(cairoDate.getDate() - 1);
    }
    
    const y = cairoDate.getFullYear();
    const m = String(cairoDate.getMonth() + 1).padStart(2, '0');
    const d = String(cairoDate.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  const [formData, setFormData] = useState({
    station: user?.station || '',
    date: getReportDate()
  });

  const [dayAttendance, setDayAttendance] = useState([]);
  const [nightAttendance, setNightAttendance] = useState([]);
  const [dayActivities, setDayActivities] = useState([]);
  const [nightActivities, setNightActivities] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [modalValue, setModalValue] = useState('');
  const [currentEditId, setCurrentEditId] = useState(null);

  // ===== التحقق من الشيفت =====
  const getCurrentShift = () => {
    const now = new Date();
    const hour = parseInt(now.toLocaleTimeString('en-US', {
      timeZone: 'Africa/Cairo',
      hour: '2-digit',
      hour12: false
    }));
    return (hour >= 7 && hour < 19) ? 'day' : 'night';
  };

  const userShift = user?.shift === 'نهار' ? 'day' : user?.shift === 'ليل' ? 'night' : null;
  const currentShift = getCurrentShift();
  const isOutsideShiftHours = userShift && userShift !== currentShift;
  // ===== نهاية التحقق =====

  const stations = [
    'المعمل المركزي + الفسطاط 17',
    'الملك الصالح 16',
    'الروضة 15',
    'ميدان الجيزة 14',
    'الجيزة 13'
  ];

  const translateRole = (role) => {
    const roles = {
      'engineer': 'مهندس',
      'supervisor': 'سوبر فايزر',
      'senior': 'سنيور',
      'technician': 'فني',
      'assistant': 'مساعد',
      'admin': 'مدير'
    };
    return roles[role] || role;
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const openModal = (type, id = null, currentValue = '') => {
    setModalType(type);
    setCurrentEditId(id);
    setModalValue(currentValue);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalType('');
    setModalValue('');
    setCurrentEditId(null);
  };

  const partialSaveToDatabase = async () => {
    try {
      const token = localStorage.getItem('token');
      
      const cleanAttendance = (arr) => arr.filter(a => a.name.trim()).map(({ id, ...rest }) => rest);
      const cleanActivities = (arr) => arr.filter(a => a.description.trim()).map(({ id, ...rest }) => rest);
      
      const reportData = {
        station: formData.station,
        date: formData.date,
        dayAttendance: cleanAttendance(dayAttendance),
        nightAttendance: cleanAttendance(nightAttendance),
        dayActivities: cleanActivities(dayActivities),
        nightActivities: cleanActivities(nightActivities)
      };

      const response = await fetch('https://metro4.dcairo.com/api/reports/partial-save', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(reportData)
      });

      const data = await response.json();
      
      if (!data.success) {
        console.error('فشل الحفظ في قاعدة البيانات:', data.message);
      }
    } catch (error) {
      console.error('خطأ في الحفظ:', error);
    }
  };

  const handleModalSave = async () => {
    if (!modalValue.trim()) {
      toast.error('من فضلك اكتب تعليق');
      return;
    }

    let updatedDayAttendance = dayAttendance;
    let updatedNightAttendance = nightAttendance;
    let updatedDayActivities = dayActivities;
    let updatedNightActivities = nightActivities;

    if (modalType.includes("Attendance")) {
      const enteredName = modalValue.trim();
      if (modalType === "dayAttendance") {
        updatedDayAttendance = dayAttendance.map(a =>
          a.id === currentEditId ? { ...a, name: enteredName } : a
        );
        setDayAttendance(updatedDayAttendance);
      } else if (modalType === "nightAttendance") {
        updatedNightAttendance = nightAttendance.map(a =>
          a.id === currentEditId ? { ...a, name: enteredName } : a
        );
        setNightAttendance(updatedNightAttendance);
      }
    } else if (modalType === "dayActivity") {
      const { cairoTime } = getCurrentTimeAndShift();
      const addedBy = `${user.fullName} (${translateRole(user.role)})`;
      updatedDayActivities = dayActivities.map(a =>
        a.id === currentEditId
          ? { ...a, description: modalValue.trim(), exactTime: cairoTime, addedBy: addedBy }
          : a
      );
      setDayActivities(updatedDayActivities);
    } else if (modalType === "nightActivity") {
      const { cairoTime } = getCurrentTimeAndShift();
      const addedBy = `${user.fullName} (${translateRole(user.role)})`;
      updatedNightActivities = nightActivities.map(a =>
        a.id === currentEditId
          ? { ...a, description: modalValue.trim(), exactTime: cairoTime, addedBy: addedBy }
          : a
      );
      setNightActivities(updatedNightActivities);
    }

    closeModal();
    
    try {
      const token = localStorage.getItem('token');
      
      const cleanAttendance = (arr) => arr.filter(a => a.name.trim()).map(({ id, ...rest }) => rest);
      const cleanActivities = (arr) => arr.filter(a => a.description.trim()).map(({ id, ...rest }) => rest);
      
      const reportData = {
        station: formData.station,
        date: formData.date,
        dayAttendance: cleanAttendance(updatedDayAttendance),
        nightAttendance: cleanAttendance(updatedNightAttendance),
        dayActivities: cleanActivities(updatedDayActivities),
        nightActivities: cleanActivities(updatedNightActivities)
      };

      const response = await fetch('https://metro4.dcairo.com/api/reports/partial-save', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(reportData)
      });

      const data = await response.json();
      
      if (data.success) {
        toast.success('تم إضافة التعليق بنجاح');
      } else {
        toast.error(data.message || 'فشل في إضافة التعليق');
      }
    } catch (error) {
      toast.error('خطأ في الاتصال');
    }
    setLoading(false);
  };
  React.useEffect(() => {
    setDayAttendance(Array(5).fill(null).map((_, i) => ({
      id: `day-att-${i}`,
      shift: 'نهار',
      name: ''
    })));
    setNightAttendance(Array(5).fill(null).map((_, i) => ({
      id: `night-att-${i}`,
      shift: 'ليل',
      name: ''
    })));
    setDayActivities(Array(8).fill(null).map((_, i) => ({
      id: `day-${i}`,
      description: '',
      exactTime: '',
      shift: 'نهار',
      addedBy: ''
    })));
    setNightActivities(Array(8).fill(null).map((_, i) => ({
      id: `night-${i}`,
      description: '',
      exactTime: '',
      shift: 'ليل',
      addedBy: ''
    })));
  }, []);

  React.useEffect(() => {
    if (user?.station) {
      let stationName = user.station;
      if (stationName === 'المعمل المركزي' || stationName === 'الفسطاط 17') {
        stationName = 'المعمل المركزي + الفسطاط 17';
      }
      setFormData(prev => ({ ...prev, station: stationName }));
    }
  }, [user]);

  React.useEffect(() => {
    const fetchAllUsers = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch('https://metro4.dcairo.com/api/users', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const data = await response.json();
        if (data.success) {
          setAllUsers(data.data.users || []);
        }
      } catch (error) {
        console.error('خطأ في جلب المستخدمين:', error);
      }
    };
    fetchAllUsers();
  }, []);

  React.useEffect(() => {
    const fetchExistingReport = async () => {
      if (!formData.station || !formData.date) return;
      
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(
          `https://metro4.dcairo.com/api/reports?station=${encodeURIComponent(formData.station)}&date=${formData.date}`,
          {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          }
        );
        const data = await response.json();
        
        if (data.success && data.data.reports && data.data.reports.length > 0) {
          const report = data.data.reports[0];
          
          if (report.dayAttendance && report.dayAttendance.length > 0) {
            const existingDayAtt = report.dayAttendance.map((att, i) => ({
              id: `day-att-${i}`,
              shift: 'نهار',
              name: att.name || ''
            }));
            while (existingDayAtt.length < 5) {
              existingDayAtt.push({
                id: `day-att-${existingDayAtt.length}`,
                shift: 'نهار',
                name: ''
              });
            }
            setDayAttendance(existingDayAtt);
          }
          
          if (report.nightAttendance && report.nightAttendance.length > 0) {
            const existingNightAtt = report.nightAttendance.map((att, i) => ({
              id: `night-att-${i}`,
              shift: 'ليل',
              name: att.name || ''
            }));
            while (existingNightAtt.length < 5) {
              existingNightAtt.push({
                id: `night-att-${existingNightAtt.length}`,
                shift: 'ليل',
                name: ''
              });
            }
            setNightAttendance(existingNightAtt);
          }
          
          if (report.dayActivities && report.dayActivities.length > 0) {
            const existingDayAct = report.dayActivities.map((act, i) => ({
              id: `day-${i}`,
              description: act.description || '',
              exactTime: act.exactTime || '',
              shift: 'نهار',
              addedBy: act.addedBy || ''
            }));
            while (existingDayAct.length < 8) {
              existingDayAct.push({
                id: `day-${existingDayAct.length}`,
                description: '',
                exactTime: '',
                shift: 'نهار',
                addedBy: ''
              });
            }
            setDayActivities(existingDayAct);
          }
          
          if (report.nightActivities && report.nightActivities.length > 0) {
            const existingNightAct = report.nightActivities.map((act, i) => ({
              id: `night-${i}`,
              description: act.description || '',
              exactTime: act.exactTime || '',
              shift: 'ليل',
              addedBy: act.addedBy || ''
            }));
            while (existingNightAct.length < 8) {
              existingNightAct.push({
                id: `night-${existingNightAct.length}`,
                description: '',
                exactTime: '',
                shift: 'ليل',
                addedBy: ''
              });
            }
            setNightActivities(existingNightAct);
          }
        }
      } catch (error) {
        console.error('خطأ في جلب التقرير:', error);
      }
    };
    
    fetchExistingReport();
  }, [formData.station, formData.date]);

  const getCurrentTimeAndShift = () => {
    const now = new Date();
    const cairoTime = now.toLocaleTimeString('en-US', {
      timeZone: 'Africa/Cairo',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });

    const hour = parseInt(now.toLocaleTimeString('en-US', {
      timeZone: 'Africa/Cairo',
      hour: '2-digit',
      hour12: false
    }));

    const shift = (hour >= 7 && hour < 19) ? 'نهار' : 'ليل';
    return { cairoTime, shift };
  };

  const addDayAttendee = () => {
    const newId = `day-att-${Date.now()}`;
    setDayAttendance([...dayAttendance, {
      id: newId,
      shift: 'نهار',
      name: ''
    }]);
  };

  const addNightAttendee = () => {
    const newId = `night-att-${Date.now()}`;
    setNightAttendance([...nightAttendance, {
      id: newId,
      shift: 'ليل',
      name: ''
    }]);
  };

  const addDayActivity = () => {
    const newId = `day-${Date.now()}`;
    setDayActivities([...dayActivities, {
      id: newId,
      description: '',
      exactTime: '',
      shift: 'نهار',
      addedBy: ''
    }]);
  };

  const addNightActivity = () => {
    const newId = `night-${Date.now()}`;
    setNightActivities([...nightActivities, {
      id: newId,
      description: '',
      exactTime: '',
      shift: 'ليل',
      addedBy: ''
    }]);
  };

  const handleDeleteAttendance = async (type, id) => {
    if (!user || user.role !== 'admin') {
      toast.error('غير مصرح لك بالحذف');
      return;
    }

    if (type === 'dayAttendance') {
      const updated = dayAttendance.map(a => 
        a.id === id ? { ...a, name: '' } : a
      );
      setDayAttendance(updated);
      await partialSaveToDatabase();
      toast.success('تم حذف الاسم');
    } else if (type === 'nightAttendance') {
      const updated = nightAttendance.map(a => 
        a.id === id ? { ...a, name: '' } : a
      );
      setNightAttendance(updated);
      await partialSaveToDatabase();
      toast.success('تم حذف الاسم');
    }
  };

  const handleDeleteActivity = async (type, id) => {
    if (!user || user.role !== 'admin') {
      toast.error('غير مصرح لك بالحذف');
      return;
    }

    if (type === 'dayActivity') {
      const updated = dayActivities.map(a => 
        a.id === id ? { ...a, description: '', exactTime: '', addedBy: '' } : a
      );
      setDayActivities(updated);
      await partialSaveToDatabase();
      toast.success('تم حذف المهمة');
    } else if (type === 'nightActivity') {
      const updated = nightActivities.map(a => 
        a.id === id ? { ...a, description: '', exactTime: '', addedBy: '' } : a
      );
      setNightActivities(updated);
      await partialSaveToDatabase();
      toast.success('تم حذف المهمة');
    }
  };

  const handleStationChange = (e) => {
    const selectedStation = e.target.value;
    
    if (user?.role === 'admin') {
      setFormData({ ...formData, station: selectedStation });
      setDayAttendance(Array(5).fill(null).map((_, i) => ({
        id: `day-att-${i}`,
        shift: 'نهار',
        name: ''
      })));
      setNightAttendance(Array(5).fill(null).map((_, i) => ({
        id: `night-att-${i}`,
        shift: 'ليل',
        name: ''
      })));
      setDayActivities(Array(8).fill(null).map((_, i) => ({
        id: `day-${i}`,
        description: '',
        exactTime: '',
        shift: 'نهار',
        addedBy: ''
      })));
      setNightActivities(Array(8).fill(null).map((_, i) => ({
        id: `night-${i}`,
        description: '',
        exactTime: '',
        shift: 'ليل',
        addedBy: ''
      })));
      return;
    }

    if (user?.station) {
      let userStation = user.station;
      if (userStation === 'المعمل المركزي' || userStation === 'الفسطاط 17') {
        userStation = 'المعمل المركزي + الفسطاط 17';
      }
      
      if (selectedStation !== userStation) {
        const confirmChange = window.confirm(
          `⚠️ تنبيه!\n\nأنت مسجل في محطة: ${userStation}\nهل تريد فعلاً إنشاء تقرير لمحطة أخرى؟`
        );
        
        if (!confirmChange) {
          return;
        }
      }
    }
    
    setFormData({ ...formData, station: selectedStation });
  };
  return (
    <div className="dashboard">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      <div className="main-content">
        <div className="top-nav">
          <button className="menu-btn" onClick={() => setSidebarOpen(true)}>
            ☰
          </button>
          <h2>إضافة تقرير يومي</h2>
        </div>

        <div className="content-area">
          {/* ===== رسالة الشيفت ===== */}
          {isOutsideShiftHours && (
            <div style={{
              background: '#ff6b6b',
              color: 'white',
              padding: '20px',
              borderRadius: '8px',
              marginBottom: '20px',
              textAlign: 'center',
              fontSize: '16px',
              fontWeight: 'bold'
            }}>
              ⛔ أنت خارج ساعات شيفتك - لا يمكنك التسجيل حالياً
              <br/>
              شيفتك: {user?.shift}
              <br/>
              <small style={{ fontSize: '12px', marginTop: '10px', display: 'block' }}>
                {user?.shift === 'نهار' ? 'ساعات التسجيل: 7:00 ص - 6:59 م' : 'ساعات التسجيل: 7:00 م - 6:59 ص'}
              </small>
            </div>
          )}
          {/* ===== نهاية الرسالة ===== */}

          <div className="form-container" style={{ opacity: isOutsideShiftHours ? 0.5 : 1, pointerEvents: isOutsideShiftHours ? 'none' : 'auto' }}>
            <div>
              <div className="form-group">
                <label>المحطة *</label>
                <select
                  value={formData.station}
                  onChange={handleStationChange}
                  disabled={user?.role !== 'admin'}
                  required
                >
                  <option value="">اختر المحطة</option>
                  {stations.map(station => (
                    <option key={station} value={station}>{station}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>التاريخ *</label>
                <input
                  type="date"
                  value={formData.date}
                  onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                  disabled
                  required
                />
              </div>

              {currentShift === 'day' && (
                <>
                  <div className="section-title" style={{ backgroundColor: '#fff3cd', padding: '10px', borderRadius: '5px' }}>
                    إضافة الحضور - شيفت نهار
                  </div>
                  <div className="activities-section">
                    <div className="table-responsive">
                      <table className="activities-table">
                        <thead>
                          <tr>
                            <th style={{ width: '20px', minWidth: '20px', padding: '4px 2px', fontSize: '11px' }}>#</th>
                            <th style={{ width: '80%', padding: '4px', fontSize: '11px' }}>الاسم</th>
                            {user?.role === 'admin' && (
                              <th style={{ width: '40px', padding: '4px', fontSize: '11px', textAlign: 'center' }}>إجراءات</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {dayAttendance.map((att, index) => {
                            const prevFilled = index === 0 || dayAttendance[index - 1].name.trim();
                            const isFilled = att.name.trim();
                            const isClickable = prevFilled && !isFilled;
                            return (
                            <tr key={att.id}>
                              <td className="text-center">{index + 1}</td>
                              <td>
                                <input
                                  type="text"
                                  placeholder="اضغط لإضافة الاسم"
                                  value={att.name}
                                  readOnly
                                  disabled={!isClickable}
                                  onClick={() => isClickable && openModal('dayAttendance', att.id, att.name)}
                                  style={{ 
                                    cursor: isClickable ? 'pointer' : 'not-allowed',
                                    background: isFilled ? '#c8e6c9' : (isClickable ? 'white' : '#f3f4f6'),
                                    fontWeight: isFilled ? 'bold' : 'normal',
                                    color: isFilled ? '#2e7d32' : 'inherit'
                                  }}
                                />
                              </td>
                              {user?.role === 'admin' && (
                                <td style={{ textAlign: 'center' }}>
                                  {isFilled && (
                                    <>
                                      <button
                                        onClick={() => openModal('dayAttendance', att.id, att.name)}
                                        style={{
                                          background: 'none',
                                          border: 'none',
                                          cursor: 'pointer',
                                          fontSize: '18px',
                                          padding: '0 5px'
                                        }}
                                        title="تعديل"
                                      >
                                        ✏️
                                      </button>
                                      <button
                                        onClick={() => handleDeleteAttendance('dayAttendance', att.id)}
                                        style={{
                                          background: 'none',
                                          border: 'none',
                                          cursor: 'pointer',
                                          fontSize: '18px',
                                          padding: '0 5px'
                                        }}
                                        title="حذف"
                                      >
                                        🗑️
                                      </button>
                                    </>
                                  )}
                                </td>
                              )}
                            </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <button
                      type="button"
                      className="btn-add-activity"
                      onClick={addDayAttendee}
                      style={{ marginTop: '10px' }}
                    >
                      ➕ إضافة فرد
                    </button>
                  </div>

                  <div className="section-title">☀️ مهام شيفت نهار</div>
                  <div className="activities-section">
                    <div className="table-responsive">
                      <table className="activities-table">
                        <thead>
                          <tr>
                            <th className="col-num">#</th>
                            <th className="col-wide">وصف المهمة</th>
                            {user?.role === 'admin' && (
                              <th style={{ width: '40px', padding: '4px', fontSize: '11px', textAlign: 'center' }}>إجراءات</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {dayActivities.map((activity, index) => {
                            const prevFilled = index === 0 || dayActivities[index - 1].description.trim();
                            const isFilled = activity.description.trim();
                            const isClickable = prevFilled && !isFilled;
                            return (
                            <tr key={activity.id}>
                              <td className="text-center">{index + 1}</td>
                              <td>
                                <input
                                  type="text"
                                  placeholder="اضغط لإضافة المهمة"
                                  value={activity.description}
                                  readOnly
                                  disabled={!isClickable}
                                  onClick={() => isClickable && openModal('dayActivity', activity.id, activity.description)}
                                  style={{ 
                                    cursor: isClickable ? 'pointer' : 'not-allowed',
                                    background: isFilled ? '#c8e6c9' : (isClickable ? 'white' : '#f3f4f6'),
                                    fontWeight: isFilled ? 'bold' : 'normal'
                                  }}
                                />
                              </td>
                              {user?.role === 'admin' && (
                                <td style={{ textAlign: 'center' }}>
                                  {isFilled && (
                                    <>
                                      <button
                                        onClick={() => openModal('dayActivity', activity.id, activity.description)}
                                        style={{
                                          background: 'none',
                                          border: 'none',
                                          cursor: 'pointer',
                                          fontSize: '18px',
                                          padding: '0 5px'
                                        }}
                                        title="تعديل"
                                      >
                                        ✏️
                                      </button>
                                      <button
                                        onClick={() => handleDeleteActivity('dayActivity', activity.id)}
                                        style={{
                                          background: 'none',
                                          border: 'none',
                                          cursor: 'pointer',
                                          fontSize: '18px',
                                          padding: '0 5px'
                                        }}
                                        title="حذف"
                                      >
                                        🗑️
                                      </button>
                                    </>
                                  )}
                                </td>
                              )}
                            </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div style={{ display: 'flex', gap: '10px', marginTop: '10px', alignItems: 'center' }}>
                      <button
                        type="button"
                        className="btn-save"
                        onClick={partialSaveToDatabase}
                        style={{ padding: '8px 20px', fontSize: '14px' }}
                      >
                        💾 حفظ
                      </button>
                      <button
                        type="button"
                        className="btn-add-activity"
                        onClick={addDayActivity}
                      >
                        ➕ إضافة مهمة
                      </button>
                    </div>
                  </div>
                </>
              )}

              {currentShift === 'night' && (
                <>
                  <div className="section-title" style={{ backgroundColor: '#d4edff', padding: '10px', borderRadius: '5px' }}>
                    إضافة الحضور - شيفت ليل
                  </div>
                  <div className="activities-section">
                    <div className="table-responsive">
                      <table className="activities-table">
                        <thead>
                          <tr>
                            <th style={{ width: '20px', minWidth: '20px', padding: '4px 2px', fontSize: '11px' }}>#</th>
                            <th style={{ width: '80%', padding: '4px', fontSize: '11px' }}>الاسم</th>
                            {user?.role === 'admin' && (
                              <th style={{ width: '40px', padding: '4px', fontSize: '11px', textAlign: 'center' }}>إجراءات</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {nightAttendance.map((att, index) => {
                            const prevFilled = index === 0 || nightAttendance[index - 1].name.trim();
                            const isFilled = att.name.trim();
                            const isClickable = prevFilled && !isFilled;
                            return (
                            <tr key={att.id}>
                              <td className="text-center">{index + 1}</td>
                              <td>
                                <input
                                  type="text"
                                  placeholder="اضغط لإضافة الاسم"
                                  value={att.name}
                                  readOnly
                                  disabled={!isClickable}
                                  onClick={() => isClickable && openModal('nightAttendance', att.id, att.name)}
                                  style={{ 
                                    cursor: isClickable ? 'pointer' : 'not-allowed',
                                    background: isFilled ? '#c8e6c9' : (isClickable ? 'white' : '#f3f4f6'),
                                    fontWeight: isFilled ? 'bold' : 'normal',
                                    color: isFilled ? '#2e7d32' : 'inherit'
                                  }}
                                />
                              </td>
                              {user?.role === 'admin' && (
                                <td style={{ textAlign: 'center' }}>
                                  {isFilled && (
                                    <>
                                      <button
                                        onClick={() => openModal('nightAttendance', att.id, att.name)}
                                        style={{
                                          background: 'none',
                                          border: 'none',
                                          cursor: 'pointer',
                                          fontSize: '18px',
                                          padding: '0 5px'
                                        }}
                                        title="تعديل"
                                      >
                                        ✏️
                                      </button>
                                      <button
                                        onClick={() => handleDeleteAttendance('nightAttendance', att.id)}
                                        style={{
                                          background: 'none',
                                          border: 'none',
                                          cursor: 'pointer',
                                          fontSize: '18px',
                                          padding: '0 5px'
                                        }}
                                        title="حذف"
                                      >
                                        🗑️
                                      </button>
                                    </>
                                  )}
                                </td>
                              )}
                            </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <button
                      type="button"
                      className="btn-add-activity"
                      onClick={addNightAttendee}
                      style={{ marginTop: '10px' }}
                    >
                      ➕ إضافة فرد
                    </button>
                  </div>

                  <div className="section-title">🌙 مهام شيفت ليل</div>
                  <div className="activities-section">
                    <div className="table-responsive">
                      <table className="activities-table">
                        <thead>
                          <tr>
                            <th className="col-num">#</th>
                            <th className="col-wide">وصف المهمة</th>
                            {user?.role === 'admin' && (
                              <th style={{ width: '40px', padding: '4px', fontSize: '11px', textAlign: 'center' }}>إجراءات</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {nightActivities.map((activity, index) => {
                            const prevFilled = index === 0 || nightActivities[index - 1].description.trim();
                            const isFilled = activity.description.trim();
                            const isClickable = prevFilled && !isFilled;
                            return (
                            <tr key={activity.id}>
                              <td className="text-center">{index + 1}</td>
                              <td>
                                <input
                                  type="text"
                                  placeholder="اضغط لإضافة المهمة"
                                  value={activity.description}
                                  readOnly
                                  disabled={!isClickable}
                                  onClick={() => isClickable && openModal('nightActivity', activity.id, activity.description)}
                                  style={{ 
                                    cursor: isClickable ? 'pointer' : 'not-allowed',
                                    background: isFilled ? '#c8e6c9' : (isClickable ? 'white' : '#f3f4f6'),
                                    fontWeight: isFilled ? 'bold' : 'normal'
                                  }}
                                />
                              </td>
                              {user?.role === 'admin' && (
                                <td style={{ textAlign: 'center' }}>
                                  {isFilled && (
                                    <>
                                      <button
                                        onClick={() => openModal('nightActivity', activity.id, activity.description)}
                                        style={{
                                          background: 'none',
                                          border: 'none',
                                          cursor: 'pointer',
                                          fontSize: '18px',
                                          padding: '0 5px'
                                        }}
                                        title="تعديل"
                                      >
                                        ✏️
                                      </button>
                                      <button
                                        onClick={() => handleDeleteActivity('nightActivity', activity.id)}
                                        style={{
                                          background: 'none',
                                          border: 'none',
                                          cursor: 'pointer',
                                          fontSize: '18px',
                                          padding: '0 5px'
                                        }}
                                        title="حذف"
                                      >
                                        🗑️
                                      </button>
                                    </>
                                  )}
                                </td>
                              )}
                            </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div style={{ display: 'flex', gap: '10px', marginTop: '10px', alignItems: 'center' }}>
                      <button
                        type="button"
                        className="btn-save"
                        onClick={partialSaveToDatabase}
                        style={{ padding: '8px 20px', fontSize: '14px' }}
                      >
                        💾 حفظ
                      </button>
                      <button
                        type="button"
                        className="btn-add-activity"
                        onClick={addNightActivity}
                      >
                        ➕ إضافة مهمة
                      </button>
                    </div>
                  </div>
                </>
              )}

            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3 className="modal-title">
              {modalType.includes('Attendance') ? 'إضافة اسم' : 'إضافة مهمة'}
            </h3>
            <textarea
              className="modal-input"
              placeholder={modalType.includes('Attendance') ? 'اكتب الاسم هنا...' : 'اكتب المهمة هنا...'}
              value={modalValue}
              onChange={(e) => setModalValue(e.target.value)}
              autoFocus
              rows={modalType.includes('Attendance') ? 2 : 4}
            />
            <div className="modal-actions">
              <button className="btn-modal-save" onClick={handleModalSave}>
                حفظ
              </button>
              <button className="btn-modal-cancel" onClick={closeModal}>
                إلغاء
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddReport;